import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {ACTIVE_DATA_ENABLED} from '../../../constants'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from '../../../utils/site-config'

const AppHelmet = ({normalizedLang, appConfig}) => {
    const {site} = useMultiSite()
    const siteId = site?.id
    const GTM_ENABLED = getSiteEnvVarValue(appConfig, 'GTM_ENABLED', siteId)
    const GARAGE_GTM_CONTAINER_ID = getSiteEnvVarValue(appConfig, 'GARAGE_GTM_CONTAINER_ID', siteId)

    return (
    <Helmet htmlAttributes={{lang: normalizedLang}}>
        {/* Preconnect to critical third-party origins */}
        <link rel="preconnect" href="https://edge.disstg.commercecloud.salesforce.com" />
        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <link rel="dns-prefetch" href="https://js.klarna.com" />
        <link rel="dns-prefetch" href="https://cdn.noibu.com" />
        {/* Preload critical fonts */}
        <link
            rel="preload"
            href={getAssetUrl('static/fonts/GarageNeue-Regular.woff2')}
            as="font"
            type="font/woff2"
            crossOrigin="anonymous"
        />
        <link
            rel="preload"
            href={getAssetUrl('static/fonts/GarageNeue-Medium.woff2')}
            as="font"
            type="font/woff2"
            crossOrigin="anonymous"
        />
        <link
            rel="preload"
            href={getAssetUrl('static/fonts/GarageNeue-Bold.woff2')}
            as="font"
            type="font/woff2"
            crossOrigin="anonymous"
        />
        {/* Preload GTM script - downloads in parallel with Didomi */}
        {GTM_ENABLED == 'true' && GARAGE_GTM_CONTAINER_ID && (
            <link
                rel="preload"
                href={`https://www.googletagmanager.com/gtm.js?id=${GARAGE_GTM_CONTAINER_ID}`}
                as="script"
            />
        )}
        {ACTIVE_DATA_ENABLED && (
            <script
                src={getAssetUrl('static/head-active_data.js')}
                id="headActiveData"
                type="text/javascript"
            ></script>
        )}
    </Helmet>
    )
}
AppHelmet.propTypes = {
    normalizedLang: PropTypes.string.isRequired,
    appConfig: PropTypes.object.isRequired
}

export default AppHelmet
